{
  "version": 1,
  "asset_id": "17eef7e5-3bf0-4075-913b-e804a4f4d93b",
  "project_id": "1c7313b7-7160-4256-be8b-cc48c05288da",
  "url": "/__l5e/assets-v1/17eef7e5-3bf0-4075-913b-e804a4f4d93b/aleph-commodities-1920.webp",
  "r2_key": "a/v1/1c7313b7-7160-4256-be8b-cc48c05288da/17eef7e5-3bf0-4075-913b-e804a4f4d93b/aleph-commodities-1920.webp",
  "original_filename": "aleph-commodities-1920.webp",
  "size": 590482,
  "content_type": "image/webp",
  "created_at": "2026-10-20T23:04:54Z"
}
